@use '../../style/globals.scss' as *;

// Matches profile v2 colours
$foreground-primary: white;
$foreground-secondary: #797979;
$foreground-tertiary: #a1a1a1;
// $foreground-alt: #2c2c2c;

$background-primary: #111111;
$background-secondary: #1b1b1b;
// $background-tertiary: #181818;
$background-highlight: #313131;
// $background-alt: #d9d9d9;

.RedeemRewardModal {
    text-wrap: pretty;

    .modal {
        width: 332px;
        max-width: calc(100% - 40px);
        height: auto;
        padding: 0;
        background-color: $background-secondary;
        color: $foreground-primary;
        text-align: center;
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 20px 16px;
    }

    .modalTitle {
        padding: 16px 0 12px;
        margin: 0;
        font-family: var(--font-quaternary);
        font-size: $font-size-h5;
        font-weight: bold;
    }

    .rewardImageContainer {
        position: relative;
        overflow: hidden;
        width: 100%;
        border-radius: 12px;
        aspect-ratio: 16 / 9;
        background-color: $background-highlight;

        .rewardImage {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .rewardImagePlaceholder {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;

            svg path {
                fill: $foreground-secondary;
            }
        }
    }

    .textContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        width: 100%;
        padding: 16px 10px;
        gap: 2px;

        .title {
            margin: 0;
            font-size: $font-size-h5;
            font-weight: bold;
        }

        .description {
            margin: 0;
            color: $foreground-tertiary;
            font-size: $font-size-p;
            font-weight: normal;
            line-height: 16px;
            text-transform: none;
        }

        .readMoreLink {
            display: block;
            margin-top: 5px;
            color: $foreground-secondary;
            font-size: $font-size-p;
            text-decoration: underline;

            &:hover {
                filter: brightness(1.5);
            }
        }

        .readMoreText {
            display: block;
            margin-top: 5px;
            color: $foreground-secondary;
            font-size: 9px;
        }

        .redemptionInstructions {
            margin: 0;
            margin-top: 8px;
            color: $foreground-secondary;
            font-size: 9px;
        }
    }

    .errorDescription {
        margin-top: 16px;
        color: $foreground-tertiary;
        font-size: 14px;
        font-weight: normal;
        text-transform: none;
    }

    .rewardContainer {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        width: 100%;

        .codeRow {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 8px 12px;
            background-color: $background-primary;
            border-radius: 8px;
            gap: 12px;
            color: $foreground-primary;

            .codeValue {
                flex: 1;
                font-size: 20px;
                text-align: left;
                word-break: break-all;
                text-wrap: pretty;

                &.longCode {
                    font-size: 15px;
                }
            }

            .copyButton {
                display: flex;
                flex-shrink: 0;
                justify-content: flex-end;
                align-items: center;
                min-width: 72px;
                border: none;
                background: none;
                color: $foreground-secondary;
                font-size: $font-size-p;
                gap: 6px;
                cursor: pointer;

                svg path {
                    fill: $foreground-secondary;
                }

                &:hover {
                    filter: brightness(1.5);
                }
            }
        }

        .barcodeContainer {
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            width: 100%;
            background-color: $background-primary;

            .barcodeImage {
                display: block;
                width: 100%;
                min-height: 50px;
                object-fit: contain;
            }
        }

        .qrContainer {
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            background-color: $background-primary;
            aspect-ratio: 1 / 1;

            .qrImage {
                box-sizing: content-box;
                width: 110px;
                height: 110px;
                padding: 16px;
                object-fit: contain;
            }
        }
    }

    .ctaContainer {
        box-sizing: border-box;
        width: 100%;
        padding-top: 16px;

        .ctaButton {
            width: 100%;
            padding: 14px;
            background-color: $background-highlight;
            color: $foreground-primary;
            font-family: var(--font-quaternary);
            font-size: $font-size-h6;
            font-weight: bold;

            &:hover {
                filter: brightness(1.5);
            }
        }
    }
}
